import * as React from "react";
import Box from "@mui/material/Box";
import axios from "axios";
import { genURL } from "../../_getjson";
import CustomDataGrid from "../../Components/CustomDataGrid/CustomDataGrid";
import CustomBackdrop from "../../Components/CustomBackdrop/Barckdrop";
import CustomInput from "../../Components/CustomInput/CustomInput";
import { Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import {
  blackColor,
  defaultFont,
  grayColor,
} from "../../assets/jss/psstyle/psacount";
import UseAutocompletes from "../../Components/CustomInput/UseAutocompletes";
import PropTypes from "prop-types";

const columns = [
  { field: "id", headerName: "id", width: 40, hide: true },
  {
    field: "code",
    headerName: "รหัส",
    width: 200,
    editable: false,
  },
  {
    field: "nameth",
    headerName: "ชื่อ/คำอธิบาย",
    width: 300,
    editable: false,
    flex: 1,
  },
];

export default function ReportDatagrid(props) {
  const { defaultData } = props;
  const [openbackdrop, setopenbackdrop] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [Inputtext, setInputtext] = React.useState("");
  const [reporgroupData, setReporgroupData] = React.useState([]);
  const [reporgroupval, setreporgroupval] = React.useState(1);

  React.useEffect(() => {
    loadData("all");
    getCategory();
    return () => {};
  }, []);
  const loadData = async (val) => {
    setopenbackdrop(true);
    let url = "";
    if (val === "all") {
      url = `reportmanage/report?`;
    } else {
      url = `reportmanage/report/${reporgroupval}?`;
    }
    await console.log("elementzzzzzzzzzzz", genURL(url));
    let rs = await axios.get(genURL(url), { timeout: 12000 });
    let element = [];
    await console.log("elementzzzzzzzzzzz rs.data.length", rs);
    if (rs.data.length > 0) {
      console.log("rs", rs.data);

      for (let index = 0; index < rs.data.length; index++) {
        element.push({
          id: Number(index) + 1,
          code: rs.data[index].id,
          nameth: rs.data[index].nameTH,
        });
        // console.log("rs elementzzzzzzzzzzz", rs.data[index].code);
      }
      // await setusedata(element)
      await setRows(element);
    } else {
      await setRows([]);
    }
    await setopenbackdrop(false);

    console.log("loadData search reporgroupval", reporgroupval);
  };

  const resData = (e) => {
    console.log("resData resData", e);
  };
  const removeresData = (e) => {
    console.log("resData removeresData", e);
  };
  const selcetRow = (e) => {
    props.Dataselect(e);

    // console.log("selcetRow", e)
  };
  const resinput = (e) => {
    setInputtext(e);
  };
  const keyDown = (e) => {
    console.log(e);
    if (e === "Enter") {
      loadData("search");
      if (Inputtext === "") {
        loadData("all");
      }
    }
  };
  const setvalue = async (e) => {
    console.log("setvalue", e[0].CODE);
    await setreporgroupval(e[0].CODE);
  };

  const onUseAutocompleteactivate = () => {
    console.log("onUseAutocompleteactivate");
  };

  const getCategory = async () => {
    let url = "/reportmanage/category?";
    let elementcategory = [];
    await axios
      .get(genURL(url))
      .then((res) => {
        // await axios.post(genpostURLTEST(url), parameter).then(res => {
        console.log("resdata getCategory", res.data);
        // elementcategory = res.data
        // console.log("resdata", res.data);
        if (res.data.length > 0) {
          for (let index = 0; index < res.data.length; index++) {
            if (res.data[index].catelevel == 0) {
              elementcategory.push({
                CODE: res.data[index].id,
                MYNAMETH: res.data[index].nameTH,
              });
            }
          }
        }
      })
      .catch((error) => {
        console.log("resdata", error);
        // this.setState({ opensnackbar: true })
        // this.setState({ color: "warning" })
        // this.setState({ icon: ErrorIcon })
        // this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
        // this.setState({ openBackdrop: false })
      });
    await console.log("elementcategory", elementcategory);
    await setReporgroupData(elementcategory);
  };

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      <Stack direction="row" spacing={0} mt={1} mb={1}>
        {" "}
        <UseAutocompletes
          title={"หมวดหมู่"}
          id={"reportgroupinput"}
          datalist={reporgroupData}
          valueReturn={(e) => setvalue(e)}
          activate={(_) => onUseAutocompleteactivate()}
          placeholder={""}
          defaultvalue={reporgroupval}
        />
        <CustomInput
          label={"คำค้น"}
          resData={(e) => resinput(e)}
          inputType={"text"}
          keyDown={(e) => keyDown(e)}
        />
        <Button
          variant="outlined"
          startIcon={<SearchRoundedIcon />}
          sx={{
            pt: -5,
            height: "32px",
            mt: 1.4,
            borderColor: grayColor[11],
            color: blackColor[0],
            fontFamily: defaultFont,
          }}
          onClick={(e) => loadData("search")}
        >
          ค้นหา
        </Button>
      </Stack>
      {rows.length > 0 ? (
        <CustomDataGrid
          datacolumns={columns}
          datarows={rows}
          rowHeight={38}
          Dataintable={(e) => resData(e)}
          Dataintableremove={(e) => removeresData(e)}
          startRow={1}
          option={[{ add: false, del: false, select: true }]}
          checkboxSelection
          Dataselect={(e) => selcetRow(e)}
          RowsModelChange={(_) => console.log("RowsModelChange")}
        />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} textAlign={"center"}>
            ไม่พบข้อมูล
          </Grid>
        </Grid>
      )}
      <CustomBackdrop open={openbackdrop} />
    </Box>
  );
}

ReportDatagrid.prototype = {
  defaultData: PropTypes.any,
};
